// German for NetworkZone.tsx (BUILD-BRIEF-R5 §6.2, §6.6). Keys already carried by
// `i18n/common.de.ts` (Save, Cancel, Loading…, Saving…, not collected, proposed, organisation,
// Network, Retract…) are not repeated here.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Payer mix': 'Kostenträger-Mix',
  'Names': 'Nennt',
  'Named by': 'Genannt von',
  'attributed': 'zugeordnet',
  'held by rule': 'nach Regel übernommen',
  'estimated': 'geschätzt',
  'regime, no body named': 'Regime, keine Stelle genannt',
  'of revenue': 'des Erträge',
  'Add link': 'Verknüpfung hinzufügen',
  'Open in network': 'Im Netzwerk öffnen',
  'Open organisation': 'Organisation öffnen',
  'Clear focus': 'Fokus aufheben',
  'Length': 'Länge',
  'largest first; a bar is a length on a zero baseline, the dotted rest unattributed':
    'grösste zuerst; ein Balken ist eine Länge ab Nullbasis, der gepunktete Rest nicht zugeordnet',
  'Σ of the shares above — computed, carries no mark': 'Σ der Anteile oben — berechnet, ohne Anspruchszeichen',
  '{r} % unattributed': '{r} % nicht zugeordnet',
  '{q} of {who}’s {basis} — the dotted rest goes to its other payers':
    '{q} von {who}s {basis} — der gepunktete Rest geht an seine anderen Kostenträger',
  'known providers account for {n} of the channel’s {m} people in a measure ({when}); the rest is not accounted for':
    'bekannte Anbieter stehen für {n} der {m} Personen des Kanals in einer Massnahme ({when}); für den Rest steht niemand',
  'the channel counts {m} people in a measure ({when}); no provider gives a count yet':
    'der Kanal zählt {m} Personen in einer Massnahme ({when}); noch kein Anbieter nennt eine Zahl',
  'channel volume not collected — the coverage has no denominator until a run reads channel.measure_participants':
    'Kanalvolumen nicht erhoben — die Abdeckung hat keinen Nenner, bis ein Auftrag channel.measure_participants liest',
  'Correct figure': 'Zahl korrigieren',
  'Mark ended': 'Als beendet markieren',
  'In Review': 'In der Prüfung',
  'No link is on the record for this organisation. A research run files the payers, mandants and federations its pages name.':
    'Für diese Organisation ist keine Verknüpfung erfasst. Ein Rechercheauftrag erfasst die Kostenträger, Auftraggeber und Verbände, die ihre Seiten nennen.',
  '{n} of {m} organisations give a count': '{n} von {m} Organisationen nennen eine Zahl',
  'The network could not be read: {error}': 'Das Netzwerk konnte nicht gelesen werden: {error}',

  'Counterpart': 'Gegenpartei',
  'Share': 'Anteil',
  'Claim': 'Anspruch',
  'Evidence': 'Beleg',
  'not found': 'nicht gefunden',
  'Show': 'Zeigen',
  'hide evidence': 'Beleg ausblenden',
  'Role': 'Rolle',
  'Quantity': 'Menge',
  'Period': 'Zeitraum',
  'regime': 'Regime',
  'Organisation': 'Organisation',
  'Beneficiaries': 'Begünstigte',
  'Year': 'Jahr',
  'participants': 'Teilnehmende',
  'places': 'Plätze',

  'Regime': 'Regime',
  'Residual': 'Rest',
  'Basis': 'Basis',
  'None': 'Keine',
  'Note': 'Notiz',
  'Ended on': 'Beendet am',
  'Name, ref…': 'Name, Referenz…',
  'Pick an organisation from the list.': 'Eine Organisation aus der Liste wählen.',
}, 'NetworkZone');
